import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-access-item-cta',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './access-item-cta.component.html',
  styleUrl: './access-item-cta.component.scss',
})
export class AccessItemCtaComponent {}
